import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { CheckboxInput } from '../CheckboxInput';
import i18next from 'i18next';

class UserEnable2FAForm extends React.Component {

  constructor(props) {
    super(props);

    this.props.initialize({
      enable2fa: this.props.requireTwoFactor
    });
  }

  render() {
    const { handleSubmit } = this.props;

    return (
        <div>
          <form onSubmit={handleSubmit}>
            <div className="op-content-box op-card form-group">
              <div>
                <p className="panel-heading">Two Factor Authentication:</p>
              </div>
              <div className='inline-checkbox'>
                <Field
                        name="enable2fa"
                        type="checkbox"
                        className="inline"
                        component={CheckboxInput}
                        label={i18next.t('enabled')}
                    />
              </div>
              <div className="pull-right">
                <button type="submit" className="btn btn-primary">{i18next.t('form-labels.save')}</button>
              </div>
            </div>
          </form>
        </div>
    );
  }

}

export default reduxForm({ form: 'UserEnable2FAForm' })(UserEnable2FAForm);
